export const CLOUDINARY_BASE_URL =
  'https://res.cloudinary.com/mixtiles/image/upload'
